/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
// import classNames from 'classnames';
import { useSearch } from 'wouter';
import queryString from 'query-string';
import { Pagination, Spinner } from '@micromag/core/components';
import { useUrlGenerator } from '@micromag/core/contexts';

import useThemes from '../../hooks/useThemes';
import ThemesList from '../lists/Themes';
import EmptyThemes from './EmptyThemes';

const propTypes = {
    route: PropTypes.string,
    count: PropTypes.number,
    className: PropTypes.string,
};

const defaultProps = {
    route: 'organisations.themes',
    count: 12,
    className: null,
};

const AllThemes = ({ route, count, className }) => {
    const url = useUrlGenerator();
    const search = useSearch();
    const { page = 1, last = null } = useMemo(
        () => (search !== null && search.length > 0 ? queryString.parse(search) : {}),
        [search],
    );
    const finalQuery = useMemo(() => ({ last }), [last]);
    const { themes, total, lastPage, loading } = useThemes(finalQuery, page, count);
    const paginationUrl = useMemo(() => url(route), [url, route]);

    return (
        <section className={className}>
            {themes !== null ? (
                <>
                    {loading ? <Spinner /> : <ThemesList items={themes} />}
                    {lastPage > 1 ? (
                        <Pagination
                            page={parseInt(page, 10)}
                            query={finalQuery}
                            total={total}
                            lastPage={lastPage}
                            url={paginationUrl}
                            className="mt-4"
                        />
                    ) : null}
                </>
            ) : null}
            {!loading && total === 0 ? <EmptyThemes /> : null}
        </section>
    );
};

AllThemes.propTypes = propTypes;
AllThemes.defaultProps = defaultProps;

export default AllThemes;
